import React from 'react';
import { ArrowLeft, Pencil } from 'lucide-react';

const BookingHeader = ({
  onBack,
  status,
  statusColor,
  statusText,
  onUpdateStatus,
  bookingReference,
  createdAt,
  formatDate,
}) => {
  const isCompleted = status === 'completed';
  const isCancelled = status === 'cancelled';

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors w-fit"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to bookings
        </button>
        <div className="flex items-center gap-2 sm:gap-3">
          <span
            className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold capitalize ${statusColor}`}
          >
            {statusText}
          </span>
          {!isCompleted && !isCancelled && (
            <button
              type="button"
              onClick={onUpdateStatus}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 transition-colors text-xs sm:text-sm font-medium"
            >
              <Pencil className="w-3.5 h-3.5" />
              Update status
            </button>
          )}
        </div>
      </div>

      {(bookingReference || createdAt) && (
        <div className="rounded-2xl border border-gray-200 bg-white px-5 py-4 sm:px-6 sm:py-5 shadow-sm">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500 mb-1">
            Booking
          </p>
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">
            #{bookingReference}
          </h1>
          {createdAt && formatDate ? (
            <p className="mt-1 text-sm text-gray-500">Created {formatDate(createdAt)}</p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default BookingHeader;
